<template>
  <div class="repair-bill-print">
    <div class="rb-header">
      <img
        src="/media/logos/vdd_hori_logo.png"
        alt="logo"
        class="rb-logo"
      >
      <div class="rb-tagline">
        Hệ thống Mua bán - Thu cũ đổi mới - Sửa chữa
      </div>
      <div class="rb-tagline">
        ĐTDĐ - Tablet - Macbook - Laptop - Phụ kiện
      </div>
      <div class="rb-store-line">
        {{ storeAddress }} <span v-if="storePhone">- {{ storePhone }}</span>
      </div>
    </div>

    <h2 class="rb-title">HÓA ĐƠN DỊCH VỤ</h2>
    <hr class="rb-divider">

    <div class="rb-info-block">
      <div><strong>Tên Khách:</strong> {{ customerName }}</div>
      <div><strong>Số điện thoại:</strong> {{ customerPhone }}</div>
      <div><strong>Sản phẩm:</strong> {{ deviceModel }}</div>
      <div v-if="slip.imei">
        <strong>Imei:</strong> {{ slip.imei }}
      </div>
    </div>

    <hr class="rb-divider">

    <table class="rb-items">
      <thead>
        <tr>
          <th class="rb-col-name">Dịch vụ</th>
          <th class="rb-col-qty text-right">SL</th>
          <th class="rb-col-price text-right">Đơn giá</th>
          <th v-if="hasLineDiscount" class="rb-col-discount text-right">Chiết khấu</th>
          <th class="rb-col-amount text-right">Thành tiền</th>
          <th class="rb-col-warranty text-right">BH (tháng)</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(line, idx) in lineItems"
          :key="idx"
        >
          <td>{{ line.name }}</td>
          <td class="text-right">{{ line.quantity }}</td>
          <td class="text-right">{{ formatMoney(line.unitPrice) }}</td>
          <td v-if="hasLineDiscount" class="text-right">
            {{ line.lineDiscount > 0 ? '- ' + formatMoney(line.lineDiscount) : '' }}
          </td>
          <td class="text-right">{{ formatMoney(line.amount) }}</td>
          <td class="text-right">{{ line.warrantyMonths || '0' }}</td>
        </tr>
        <tr v-if="lineItems.length === 0">
          <td
            :colspan="hasLineDiscount ? 5 : 4"
            class="text-right"
          >{{ formatMoney(totalAmount) }}</td>
          <td></td>
        </tr>
      </tbody>
      <tfoot v-if="lineItems.length > 0">
        <tr class="rb-subtotal-row" v-if="billDiscountAmount > 0">
          <th :colspan="hasLineDiscount ? 4 : 3" class="text-right">Tạm tính</th>
          <th class="text-right">{{ formatMoney(subtotal) }}</th>
          <th></th>
        </tr>
        <tr class="rb-discount-row" v-if="billDiscountAmount > 0">
          <th :colspan="hasLineDiscount ? 4 : 3" class="text-right">Chiết khấu hoá đơn</th>
          <th class="text-right">- {{ formatMoney(billDiscountAmount) }}</th>
          <th></th>
        </tr>
        <tr class="rb-total-row">
          <th :colspan="hasLineDiscount ? 4 : 3" class="text-right">Tổng cộng</th>
          <th class="text-right">{{ formatMoney(totalAmount) }}</th>
          <th></th>
        </tr>
      </tfoot>
    </table>

    <!-- Khuyến mãi đã áp dụng (Coupon + Voucher) — chỉ info, không ảnh hưởng tổng. -->
    <div class="rb-promo-info" v-if="couponCode || voucherCodes.length">
      <div v-if="couponCode">
        <strong>Mã coupon:</strong> {{ couponCode }}
      </div>
      <div v-if="voucherCodes.length">
        <strong>Voucher áp dụng:</strong> {{ voucherCodes.join(', ') }}
      </div>
    </div>

    <hr class="rb-divider">

    <div class="rb-meta">
      <div><strong>Số HĐ:</strong> {{ billNumber }}</div>
      <div><strong>Số Phiếu:</strong> {{ slip.slipNumber || '-' }}</div>
      <div><strong>Ngày:</strong> {{ billDate }}</div>
      <div><strong>Ghi chú :</strong></div>
    </div>

    <div class="rb-policy">
      <div>- VDD chỉ bảo hành những linh kiện đã sửa chữa/thay thế tại VDD và đủ điều kiện:</div>
      <div>+ Máy không cong main, cong sườn, dập nát, cháy nổ, rơi vỡ, vào nước, ẩm mốc, vào hóa chất, chảy mực hoặc bị tác động ngoại lực.</div>
      <div>+ Tem bảo hành còn nguyên vẹn, không bị bong/ rách/ dán đè/ bị sửa đổi.</div>
      <div>+ Không bị tác động/can thiệp/sửa chữa bởi bên thứ 03.</div>
      <div>- Chính sách bảo hành: xem cụ thể tại web: viendiong.com - Hotline: 1800.6729</div>
      <div class="rb-strong">Ghi chú hóa đơn:</div>
      <div>- Hóa đơn chưa bao gồm phí GTGT.</div>
      <div>- Quý khách vui lòng liên hệ cửa hàng để cung cấp thông tin xuất hóa đơn GTGT trong vòng 24h tính từ ngày mua hàng.</div>
    </div>

    <div class="rb-thanks">Xin cảm ơn quý khách!</div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'PrintRepairBill',
  props: {
    slip: {
      type: Object,
      default: () => ({}),
    },
    bill: {
      type: Object,
      default: null,
    },
  },
  computed: {
    storeAddress() {
      return (this.bill && this.bill.storeAddress) || '';
    },
    storePhone() {
      return (this.bill && this.bill.storeHotline) || '';
    },
    customerName() {
      return (this.bill && this.bill.customerName) || this.slip.customerName || '-';
    },
    customerPhone() {
      return (this.bill && this.bill.customerPhone) || this.slip.customerPhone || '-';
    },
    deviceModel() {
      const name = this.slip.productName || '';
      const brand = this.slip.brandName ? `${this.slip.brandName} ` : '';
      return `${brand}${name}`.trim() || '-';
    },
    billNumber() {
      return (this.bill && this.bill.billNumber) || '-';
    },
    billDate() {
      // BE đã format sẵn 'HH:mm DD/MM/YYYY' tại billSearchService.getBillInfo
      // (xem createdAtString) — hiển thị thẳng, không re-parse qua moment.
      if (this.bill && this.bill.createdAt) return this.bill.createdAt;
      const fallback = this.slip.returnedAt || this.slip.completedAt || this.slip.createdAt;
      return fallback ? this.formatDate(fallback) : '';
    },
    lineItems() {
      // Render từ BillItems của Hoá đơn dịch vụ (Bill bán lẻ liên kết với phiếu).
      // CHÚ Ý: BE field `totalPrice` = quantity × productPrice (GROSS, trước chiết khấu) —
      // KHÔNG phải Net Amount. Vì vậy `amount` phải tự tính = gross - lineDiscount.
      //   - quantity: it.quantity / it.qty (default 1)
      //   - unitPrice: it.productPrice / it.price / it.sellingPrice
      //   - lineDiscount: discountType='2' (Percent) → gross × discount / 100; '1' (Money) → raw
      //   - amount: max(0, gross - lineDiscount)
      const items = (this.bill && this.bill.billItems) || [];
      return items
        .map((it) => {
          const qty = Number(it.quantity != null ? it.quantity : it.qty) || 1;
          const unitPriceRaw = it.productPrice || it.price || it.sellingPrice;
          let unitPrice = Number(unitPriceRaw) || 0;
          const discountRaw = Number(it.discountAmount) || 0;
          const isPercent = String(it.discountType || '') === '2';
          // Fallback Đơn giá khi BE không trả productPrice nhưng có totalPrice (gross).
          if (unitPrice === 0 && qty > 0) {
            const grossFromBE = Number(it.totalPrice) || 0;
            if (grossFromBE > 0) unitPrice = Math.round(grossFromBE / qty);
          }
          const gross = qty * unitPrice;
          const lineDiscount = isPercent
            ? Math.round(gross * discountRaw / 100)
            : discountRaw;
          const amount = Math.max(0, gross - lineDiscount);
          return {
            name: it.productName || it.name || '',
            quantity: qty,
            unitPrice,
            lineDiscount,
            amount,
            warrantyMonths: Number(it.warrantyMonthNo) || 0,
          };
        })
        // Lọc dòng rác (không có gì để hiển thị).
        .filter((l) => l.quantity > 0 || l.unitPrice > 0 || l.amount > 0);
    },
    // True khi có ÍT NHẤT 1 line có chiết khấu → render thêm cột "Chiết khấu".
    hasLineDiscount() {
      return this.lineItems.some((l) => Number(l.lineDiscount) > 0);
    },
    // Subtotal = sum line amounts (sau chiết khấu per-line, TRƯỚC chiết khấu bill-level).
    subtotal() {
      return this.lineItems.reduce((s, l) => s + (Number(l.amount) || 0), 0);
    },
    // Chiết khấu trên hoá đơn (bill-level). BE đã tính `discountValue` thành tiền mặt
    // bất kể discountType (% / fixed), ưu tiên field này; fallback `discountAmount`.
    billDiscountAmount() {
      if (!this.bill) return 0;
      const v = Number(this.bill.discountValue);
      if (v > 0) return v;
      return Number(this.bill.discountAmount) || 0;
    },
    // Mã coupon đã áp dụng cho hoá đơn (Bill.couponCode).
    couponCode() {
      return (this.bill && this.bill.couponCode) ? String(this.bill.couponCode).trim() : '';
    },
    // Danh sách mã voucher đã dùng (từ BillItem.voucherCode hoặc BillItem.vouchers[].code) — dedup.
    voucherCodes() {
      const items = (this.bill && this.bill.billItems) || [];
      const codes = new Set();
      items.forEach((it) => {
        if (it.voucherCode) codes.add(String(it.voucherCode).trim());
        if (Array.isArray(it.vouchers)) {
          it.vouchers.forEach((v) => {
            const code = v && (v.code || v.voucherCode);
            if (code) codes.add(String(code).trim());
          });
        }
      });
      return Array.from(codes).filter(Boolean);
    },
    totalAmount() {
      // Luôn compute từ line items (subtotal đã trừ chiết khấu per-line) − chiết khấu bill-level.
      // KHÔNG trust `bill.totalAmount` của BE vì field này một số case lưu gross
      // (vd trước khi cập nhật chiết khấu) → in ra số sai. subtotal là source of truth từ items.
      return Math.max(0, this.subtotal - this.billDiscountAmount);
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return '';
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    },
    formatMoney(value) {
      const num = Number(value);
      if (!num) return '0';
      return num.toLocaleString('vi-VN');
    },
  },
};
</script>

<style scoped>
.repair-bill-print {
  width: 148mm;
  margin: 0 auto;
  font-family: 'Times New Roman', serif;
  font-size: 11pt;
  color: #000;
  background: #fff;
  padding: 8mm 6mm;
}
.rb-header {
  text-align: center;
}
.rb-logo {
  max-height: 28mm;
  object-fit: contain;
}
.rb-tagline {
  font-weight: 700;
  font-size: 11pt;
  line-height: 1.3;
}
.rb-store-line {
  font-size: 10pt;
  margin-top: 2px;
}
.rb-title {
  text-align: center;
  font-size: 20pt;
  font-weight: 700;
  margin: 12px 0 4px 0;
}
.rb-divider {
  border: none;
  border-top: 1px dashed #000;
  margin: 4px 0;
}
.rb-info-block {
  margin: 6px 0;
  line-height: 1.6;
}
.rb-items {
  width: 100%;
  border-collapse: collapse;
  margin: 6px 0;
}
.rb-items th,
.rb-items td {
  padding: 3px 5px;
  vertical-align: top;
  font-size: 10.5pt;
}
.rb-items thead th {
  border-bottom: 1px solid #000;
  font-weight: 700;
  text-align: left;
}
.rb-col-name {
  width: auto;
}
.rb-col-qty {
  width: 6%;
}
.rb-col-price,
.rb-col-discount,
.rb-col-amount {
  width: 17%;
  white-space: nowrap;
}
.rb-col-warranty {
  width: 10%;
}
/* Áp dụng nowrap cho cell tiền — tránh vỡ dòng "- 24.590.000" thành 2 hàng. */
.rb-items td.text-right,
.rb-items th.text-right {
  white-space: nowrap;
}
.rb-subtotal-row th {
  border-top: 1px solid #000;
  font-weight: 500;
}
.rb-discount-row th {
  font-weight: 500;
}
.rb-total-row th {
  border-top: 1px solid #000;
  font-weight: 700;
}
.rb-promo-info {
  margin: 4px 0 6px 0;
  font-size: 10.5pt;
  line-height: 1.5;
}
.text-right {
  text-align: right;
}
.rb-meta {
  margin: 6px 0;
  line-height: 1.6;
}
.rb-policy {
  font-size: 10.5pt;
  line-height: 1.5;
}
.rb-strong {
  font-weight: 700;
  margin-top: 4px;
}
.rb-thanks {
  text-align: center;
  font-weight: 700;
  margin-top: 12px;
}
@media print {
  .repair-bill-print {
    padding: 0;
  }
  @page {
    size: A5 portrait;
    margin: 8mm;
  }
}
</style>
